import React from 'react';
import PropTypes from 'prop-types';
import { isObject, isString } from 'lodash';
import styled from 'styled-components';
import LayoutRow from '../layoutRow';

export const RowSet = ({ values, className }) => {
  if (isString(values) || isObject(values)) {
    return <FullRow element={values} className={`${className}1`} />;
  }
  if (Array.isArray(values)) {
    const rows = values.map((value, index) => {
      const key = `${value}-${index}`;
      return <FullRow key={key} element={value} className={`${className}${index}`} />;
    });
    return <React.Fragment>{rows}</React.Fragment>;
  }
  return null;
};

RowSet.propTypes = {
  values: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  className: PropTypes.string

};
RowSet.defaultProps = {
  values: undefined,
  className: 'rowset-'
};

export const FullRow = ({ element, className }) => {
  if (element) {
    return <LayoutRow elements={[element]} widths={[1]} className={className} />;
  }
  return null;
};

FullRow.propTypes = {
  element: PropTypes.node,
  className: PropTypes.string
};

FullRow.defaultProps = {
  element: null,
  className: undefined
};

const HalfWrapper = styled.div`
  & > div > div:first-child {
    padding-right: 12px;
  }
  & > div > div:last-child {
    padding-left: 12px; 
  }
`;

export const HalfRow = ({ elements, className }) => {
  const firstTwo = elements.slice(0, 2);
  return (
    <HalfWrapper>
      <LayoutRow
        elements={firstTwo}
        widths={[0.5, 0.5]}
        className={className}
      />
    </HalfWrapper>
  );
};

HalfRow.propTypes = {
  elements: PropTypes.array,
  className: PropTypes.string
};

HalfRow.defaultProps = {
  elements: [],
  className: undefined
};
